<template>
    <div class="policiesCenter">
        <ul>
            <RouterLink
                v-for="(item, index) in dataList"
                :key="index"
                :to="{name: 'PoliciesDetails',params:{xId:item.xId}}"
                tag="li"
            >
                <span>{{ item.showTime | capitalize }} <i>{{ item.showTime | capitalizes }}-{{ item.showTime | capitalizec }}</i> </span>
                <div class="title">
                    <h4>{{ item.xName }}</h4>
                    <p>{{ item.intro }}</p>
                </div>
            </RouterLink>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'PoliciesCenter',
    filters: {
        capitalize: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[0]
        },
        capitalizes: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[1]
        },
        capitalizec: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[2]
        }
    },
    props: {
        title: {
            type: Number
        },
        dataList: {
            type: Array
        }
    },
    data() {
        return {
            state: 0
        }
    },
    mounted() {
        // news/xInfo
        this.state = this.$router.currentRoute.params.xId
        // this.dataRequest()

    },
    methods: {
        dataRequest() {
            this.$api.get('news/xInfo', {
                params: {
                    xId: this.state
                }
            }).then(res => {
                this.dataList = res.data.list
                this.total = res.data.count
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.policiesCenter {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    position: relative;
    ul {
        list-style: none;
        padding: 0 40px;
        margin-top: 0;
        margin-bottom: 40px;
        li {
            border-bottom: 1px solid rgba(242, 242, 242, 1);
            display: flex;
            justify-content: space-between;
            padding: 36px 0 40px 0;
            cursor: pointer;
            span {
                display: block;
                width: 120px;
                font-size: 24px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 30px;
                text-align: center;
                i {
                    font-style: normal;
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    display: block;
                    top: 0;
                    line-height: 30px;
                }
            }
            .title {
                width: 80%;
                h4 {
                    font-size: 20px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 1);
                    line-height: 30px;
                    margin: 0;
                }
                p {
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    line-height: 24px;
                    margin-top: 4px;
                    margin-bottom: 0;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
            &:last-child {
                border: none;
            }
        }
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #243db3;
    }
    .block {
        width: 100%;
        position: absolute;
        bottom: 40px;
        ::v-deep .el-pagination {
            width: 634px;
            margin: 0 auto;
            ::v-deep li {
                background-color: #fff;
            }
        }
        ::v-deep .btn-next,
        ::v-deep .btn-prev {
            background-color: #fff;
        }
    }
}
</style>
